module.exports = __webpack_public_path__ + "img/chc.e74d08fe.jpg";